import {makeStyles} from '@material-ui/core/styles';
export const VCalendarioStyle = makeStyles ((theme) => ({
    contentMargin:{
        margin: "2%",
    }
}));